import { loadStripe, type Stripe, type StripeElements } from '@stripe/stripe-js'
import type { RootData } from '~/definitions/AllDefinitions'

export default defineNuxtPlugin({
  name: 'stripe-setup',
  hooks: {
    // wait for rootData to be ready as we will use rootData.stripeAccount
    async 'rootData:ready'(rootData: RootData) {
      const nuxt = useNuxtApp()
      const config = useRuntimeConfig()
      if (!nuxt.$stripe) {
        const s = await loadStripe(config.public.stripePk, {
          stripeAccount: rootData.stripeAccount,
        })
        if (s) {
          nuxt.provide('stripe', s as Stripe)
          if (!nuxt.$stripeElements) {
            const stripeElements: StripeElements = s.elements({
              fonts: [
                { cssSrc: 'https://fonts.googleapis.com/css2?family=Inter&display=swap' },
              ],
            })
            nuxt.provide('stripeElements', stripeElements)
          }
        }
      }
    },
  },
})
